<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="sp"> </p>
<p class="DED"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>For all the women who have supported and tolerated and argued and encouraged and listened and warned and loved, without whom life would be impossible. They know who they are.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0aa5115a